import { formatDate } from '../../lib/timeFormat';
import {
  formatLabel as formatBaggageLabel,
  formatExtraBaggageList,
  handleChange as handleBaggageChange,
  getFreeBaggage
} from './baggage';

import ACTIONS_TYPES from './actionTypes';

const BOOKING_STATUS = [
  'created',
  'offer-unavailable',
  'pending-payment',
  'payment-confirmed',
  'confirmed',
  'price-changed',
  'rescheduled',
  'canceled',
  'refunded',
];

function reducer(state, action) {
  switch (action.type) {
    case ACTIONS_TYPES.TOGGLE_STEP: {
      return {
        ...state,
        activeStep: action.step,
      };
    }

    case ACTIONS_TYPES.UPDATE_STATUS: {
      return {
        ...state,
        status: action.status,
        error: null,
        errors: {}
      };
    }

    case ACTIONS_TYPES.SET_BOOKING: {
      const { user = {}, booking } = action;
      let steps = state.steps;
      let activeStep = state.activeStep;

      const statusIndex = BOOKING_STATUS.findIndex(status => status === booking.status);

      if (booking.status === 'pending-payment') {
        steps = steps.map(step => ({ ...step, done: step !== 'payment' }));
        activeStep = booking.statusTrigger === 'payment-info-submit' ? 'final' : 'payment';
      }

      if (statusIndex > 2) activeStep = 'final';

      return {
        ...state,
        steps,
        activeStep,
        booking: {
          ...booking,
          mobile: booking.mobile || user?.mobile,
          email: booking.email || user?.email
        },
        passengers: action.booking.passengers.map((passenger, index) => ({
          ...passenger,
          baggageLabel: formatBaggageLabel(passenger.baggages),
          freeBaggage: getFreeBaggage(passenger.baggage),
          extraBaggage: formatExtraBaggageList(passenger.baggage),
          dateOfBirth: passenger.dateOfBirth && formatDate(passenger.dateOfBirth),
          documentExpiryDate: passenger.documentExpiryDate && formatDate(passenger.documentExpiryDate),
        })),
        status: 'ready'
      };
    }

    case ACTIONS_TYPES.BOOKING_CHANGE: {

      return {
        ...state,
        booking: {
          ...state.booking,
          ...action.update
        },
      };
    }

    case ACTIONS_TYPES.PASSENGER_UPDATE: {
      return {
        ...state,
        passengers: state
          .passengers.map(passenger => (passenger.id === action.passengerId
            ? { ...passenger, ...action.update }
            : passenger)),
      };
    }

    case ACTIONS_TYPES.PASSENGER_BAGGAGE_UPDATE: {
      const passenger = state.passengers.find(({ id }) => id === action.passenger.id);

      const { baggage, extraBaggage } = handleBaggageChange({
        item: action.item,
        ...passenger,
      });

      return {
        ...state,
        passengers: state
          .passengers.map(passenger => (passenger.id === action.passenger.id
            ? { ...passenger, baggage, extraBaggage }
            : passenger)),
      };
    }

    case ACTIONS_TYPES.SEAT_UPDATE: {
      return {
        ...state,
        ...action.seat,
      };
    }

    case ACTIONS_TYPES.SUBMIT_BOOKING: {
      return {
        ...state,
        steps: state.steps.map(step => step.key === 'passenger' ? { ...step, done: true } : step),
        activeStep: action.step,
        status: 'ready',
        error: null,
        errors: {}
      };
    }
    case ACTIONS_TYPES.ALERT_ERROR: {
      return {
        ...state,
        error: action.error,
        errors: action.errors || {},
        status: 'ready'
      };
    }
    case ACTIONS_TYPES.SET_EXPIRED: {
      return {
        ...state,
        expired: true
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;